
import { Component } from "vue-property-decorator";
import { TypedVue } from "@/store/types";
import LevelDot from "./LevelDot.vue";
import DiscussionFlag from "./DiscussionFlag.vue";

@Component({ components: { LevelDot, DiscussionFlag } })
export default class PrioritizationLegend extends TypedVue {}
